import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/dist/vuetify.css'

import { BLUE_THEME, AQUA_THEME, PURPLE_THEME, GREEN_THEME, CYAN_THEME, ORANGE_THEME } from '@/theme/LightTheme';
import {
    DARK_BLUE_THEME,
    DARK_AQUA_THEME,
    DARK_ORANGE_THEME,
    DARK_PURPLE_THEME,
    DARK_GREEN_THEME,
    DARK_CYAN_THEME
} from '@/theme/DarkTheme';

var theme = localStorage.getItem('theme') || 'BLUE_THEME';

// Translations provided by Vuetify
const vuetify = createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: theme,
        themes: {
            BLUE_THEME,
            AQUA_THEME,
            PURPLE_THEME,
            GREEN_THEME,
            CYAN_THEME,
            ORANGE_THEME,
            DARK_BLUE_THEME,
            DARK_AQUA_THEME,
            DARK_ORANGE_THEME,
            DARK_PURPLE_THEME,
            DARK_GREEN_THEME,
            DARK_CYAN_THEME
        }
    },
    //autoImport: true,
    // styles: {
    //     configFile: '/src/scss/_variables.scss',
    // },
    defaults: {
        VCard: {
            rounded: 'md'
        },
        VTextField: {
            variant: 'outlined',
            density: 'compact',
            color: 'primary'
        },
        VTextarea: {
            variant: 'outlined',
            density: 'compact',
            color: 'primary'
        },
        VSelect: {
            variant: 'outlined',
            density: 'compact',
            color: 'primary'
        },
        VListItem: {
            minHeight: '45px'
        },
        // VBtn: {
        //     density: 'compact',
        // },
        VTooltip: {
            location: 'top'
        },
        VAutocomplete: {
            density: 'compact',
            color: 'primary',
            variant: 'outlined',
        },
        VDateInput: {
            color: 'primary',
            variant: 'outlined',
            density: 'compact',
            hideHeader: false,
        }
    }
})

export default vuetify;
